/*!
 * Built by Revolist OU ❤️
 */
import './index-CHLNwl4l.js';

const globalFn = () => { };

const globalScripts = globalFn;

export { globalScripts as g };
//# sourceMappingURL=app-globals-CkPSYtJ_.js.map

//# sourceMappingURL=app-globals-CkPSYtJ_.js.map